module.exports = __webpack_public_path__ + "static/images/mall-wz-bg.76be28c.png";